import React from "react";
import "./login.scss";
import {
  Form,
  Field,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import FormPasswordField from "../../components/formFields/FormPasswordField";
import {
  passwordValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import { useNavigate } from "react-router-dom";
import { employeeLogin } from "./loginSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { Checkbox } from "@progress/kendo-react-inputs";
import LOGO from "../../assets/Images/logofull.png";

const LogIn: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state.login.loading);

  const handleSubmit = async (values: any) => {
    const data = {
      UserName: values.UserName,
      Password: values.Password,
    };
    const response = await dispatch(employeeLogin(data));
    if (response?.meta?.requestStatus === "fulfilled") {
      navigate("/");
    }
  };

  return (
    <div className="login-wrapper solar-theme">
      <div className="login-background">
        <div className="solar-pattern"></div>
        <div className="sun-graphic"></div>
      </div>

      <div className="login-card">
        <div className="card-header">
          <div className="logo-container">
            <div className="logo-icon">
              <img style={{ height: 70 }} src={LOGO} alt="logo" />
            </div>
            {/* <h1>Solar Mitra</h1> */}
          </div>
          <h2>Welcome Back</h2>
          <p>Access your solar energy management dashboard</p>
        </div>

        <div className="card-body">
          <Form
            onSubmit={handleSubmit}
            initialValues={{
              UserName: "",
              Password: "",
              RememberMe: false,
            }}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement>
                <Field
                  name={"UserName"}
                  type={"text"}
                  component={FormTextField}
                  label={"Username"}
                  placeholder="Enter your username"
                  validator={requiredValidator}
                />

                <Field
                  name={"Password"}
                  type={"password"}
                  component={FormPasswordField}
                  label={"Password"}
                  placeholder="Enter your password"
                  validator={passwordValidator}
                />

                <div className="form-footer">
                  <div className="remember-me">
                    <Field
                      name="RememberMe"
                      component={Checkbox}
                      id="rememberMe"
                    />
                    <label htmlFor="rememberMe">Remember me</label>
                  </div>
                  {/* <a href="/forgot-password" className="forgot-password">
                    Forgot password?
                  </a> */}
                </div>

                <ButtonWithLoading
                  label="Login"
                  themeColor="primary"
                  type="submit"
                  width="100%"
                  disabled={!formRenderProps.allowSubmit || loading}
                  loading={loading}
                  className="login-btn"
                />
              </FormElement>
            )}
          />
        </div>

        {/* <div className="card-footer">
          <p>New to our platform? <a href="/signup">Create an account</a></p>
        </div> */}
      </div>
    </div>
  );
};

export default LogIn;
